/**
 * Creates a copy of an array and reverses its elements.
 * Compared to the `reverse` method of arrays, this function does not modify the original array.
 * @param arr The array to be reversed.
 * @returns A new array containing the elements in reversed order.
 */
export function reverse<T>(arr: T[]): T[] {
  const reversedArr = new Array<T>(arr.length);

  for (let i = 0, j = arr.length - 1; i < arr.length; i++, j--) {
    reversedArr[i] = arr[j];
  }

  return reversedArr;
}

export const arrayEquals = (a: any[], b: string | any[] | undefined) =>
  Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);

/**
 * Determines if a value is duplicated in an array, excluding the element at the specified index.
 */
export function isDuplicate<T>(array: T[], value: T, index: number): boolean {
  return array.some((item, i) => item === value && i !== index);
}

/**
 * Reorders an array by moving an item from one index to another.
 * @param list The array to reorder.
 * @param startIndex
 * @param endIndex
 * @returns A new array with the item moved from startIndex to endIndex.
 */
export const reorderArray = <T>(list: readonly T[], startIndex: number, endIndex: number): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
